var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6799 7.77552C11.8939 7.77552 12.8779 6.79152 12.8779 5.57752C12.8779 4.36418 11.8939 3.37952 10.6799 3.37952",
    stroke: "white",
    strokeOpacity: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6907 10.1642C12.0533 10.1889 12.4133 10.2409 12.7687 10.3195C13.2613 10.4175 13.8547 10.6195 14.0653 11.0615C14.2 11.3449 14.2 11.6749 14.0653 11.9582C13.8553 12.4002 13.2613 12.6022 12.7687 12.7035",
    stroke: "white",
    strokeOpacity: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39416 10.6375C8.85416 10.6375 10.9555 11.0101 10.9555 12.4988C10.9555 13.9881 8.8675 14.3735 6.39416 14.3735C3.93416 14.3735 1.8335 14.0015 1.8335 12.5121C1.8335 11.0228 3.92083 10.6375 6.39416 10.6375Z",
    stroke: "white",
    strokeOpacity: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3941 8.5125C4.77144 8.5125 3.47144 7.21184 3.47144 5.58917C3.47144 3.96717 4.77144 2.6665 6.3941 2.6665C8.01677 2.6665 9.31744 3.96717 9.31744 5.58917C9.31744 7.21184 8.01677 8.5125 6.3941 8.5125Z",
    stroke: "white",
    strokeOpacity: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.3ac686bf.svg";
export { ForwardRef as ReactComponent };